import { render, staticRenderFns } from "./ModChat.vue?vue&type=template&id=5b4d2e7c&"
import script from "./ModChat.vue?vue&type=script&lang=js&"
export * from "./ModChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports